import React from 'react';
import { Box, Typography, Grid, Container } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const modules = [
  {
    number: '01',
    title: 'Lead Management & Distribution',
    color: '#684df4',
    bg: 'rgba(104,77,244,0.06)',
    border: 'rgba(104,77,244,0.2)',
    points: [
      'Capture leads from website, walk-ins, portals',
      'Auto-assign enquiries to counselors',
      'Smart lead scoring and priority tags',
      'Duplicate detection & merging',
      'WhatsApp, SMS & Email auto-responses',
    ],
  },
  {
    number: '02',
    title: 'Admission Pipeline Tracking',
    color: '#233098',
    bg: 'rgba(35,48,152,0.06)',
    border: 'rgba(35,48,152,0.2)',
    points: [
      'Visual Kanban-style admission stages',
      'Move students through funnel with one click',
      'Stage-wise follow-up reminders',
      'Counselor workload balancing',
      'Conversion rate per stage reports',
    ],
  },
  {
    number: '03',
    title: 'Document & Fee Collection',
    color: '#0ea5e9',
    bg: 'rgba(14,165,233,0.06)',
    border: 'rgba(14,165,233,0.2)',
    points: [
      'Digital document upload and verification',
      'Online fee payment links',
      'Automated fee reminder sequences',
      'Receipt generation & email delivery',
      'Pending fee dashboard per student',
    ],
  },
  {
    number: '04',
    title: 'Reports & Analytics',
    color: '#7c3aed',
    bg: 'rgba(124,58,237,0.06)',
    border: 'rgba(124,58,237,0.2)',
    points: [
      'Source-wise lead performance',
      'Counselor conversion leaderboard',
      'Daily/Weekly admission reports',
      'Drop-off analysis by stage',
      'Revenue and fee collection forecasting',
    ],
  },
];

const Modules = () => (
  <Box sx={{ py: { xs: 8, md: 12 }, bgcolor: '#f8f7ff' }}>
    <Container maxWidth="lg">
      <Box sx={{ textAlign: 'center', mb: 8 }}>
        <Typography sx={{ color: '#684df4', fontWeight: 700, fontSize: 13, letterSpacing: 2, mb: 1.5, fontFamily: "'Montserrat', sans-serif", textTransform: 'uppercase' }}>
          Platform Modules
        </Typography>
        <Typography variant="h2" sx={{ fontWeight: 800, color: '#141d38', fontFamily: "'Montserrat', sans-serif", fontSize: { xs: '1.9rem', md: '2.8rem' }, mb: 2 }}>
          Everything in One Unified Platform
        </Typography>
        <Typography sx={{ color: '#64748b', fontSize: 17, maxWidth: 600, mx: 'auto', fontFamily: "'Montserrat', sans-serif", lineHeight: 1.8 }}>
          From the first enquiry to the final enrollment — every step automated, tracked, and optimized for your team.
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {modules.map((m, i) => (
          <Grid item xs={12} md={6} key={i} mb={8} >
            <Box sx={{
              bgcolor: '#fff',
              border: `2px solid ${m.border}`,
              borderRadius: '20px',
              p: 4,
              height: '100%',
              transition: 'transform 0.3s, box-shadow 0.3s',
              '&:hover': { transform: 'translateY(-6px)', boxShadow: `0 24px 60px ${m.border}` },
            }}>
              {/* Header */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                <Box sx={{ width: 52, height: 52, borderRadius: '14px', bgcolor: m.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <Typography sx={{ fontWeight: 900, fontSize: 18, color: m.color, fontFamily: "'Montserrat', sans-serif" }}>{m.number}</Typography>
                </Box>
                <Typography variant="h6" sx={{ fontWeight: 800, color: '#141d38', fontFamily: "'Montserrat', sans-serif", fontSize: '1.05rem' }}>
                  {m.title}
                </Typography>
              </Box>
              {/* Points */}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                {m.points.map((pt, j) => (
                  <Box key={j} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                    <CheckCircleIcon sx={{ color: m.color, fontSize: 18, mt: '1px', flexShrink: 0 }} />
                    <Typography sx={{ color: '#4b5563', fontSize: 14.5, fontFamily: "'Montserrat', sans-serif", lineHeight: 1.6 }}>{pt}</Typography>
                  </Box>
                ))}
              </Box>
              {/* Link */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 3, cursor: 'pointer' }}>
                <Typography sx={{ color: m.color, fontWeight: 700, fontSize: 13, fontFamily: "'Montserrat', sans-serif" }}>Explore Module</Typography>
                <ArrowForwardIosIcon sx={{ fontSize: 12, color: m.color }} />
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export default Modules;
